import { createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const router = createRouter({
  routeTree,
  basepath: import.meta.env.PUBLIC_BASE_APP_PATHNAME || '/',
  defaultPreload: 'intent',
  defaultStaleTime: 0,
  context: {
    queryClient: null!, // This is set in the main.ts. Some circular deps issue
  },
})

export default router
